import React from "react";
import { YOUTUBE_URL } from "../../../helpers/socialMediaUrls";
import { StyledYoutubeIcon } from './YoutubeIcon.styled';

export const YoutubeIcon = () => {
    return <a href={YOUTUBE_URL} target='_blank'><StyledYoutubeIcon/></a>
}